<div class="container my-2">
  <div class="container">
    <div class="text-center">
      <img
        src="assets/images/internship-banner.png"
        alt="icons"
        class="img-fluid"
      />
    </div>
    
<div
      class="card shadow-sm mt-4 intern-card"
      
    >
      <div class="card-body">
        <h3 class="fw-bold mt-4 mb-3 text-center">Available Domains</h3>

        <div class="domaintype mt-4">
          <div class="domains-grid">
            <div class="domain-card p-3 text-center">
              <i class="bi bi-people fs-1 text-primary"></i>
              <h6 class="fw-bold mt-2">HR Internship</h6>
              <small
                >Recruitment, onboarding, HRMS tools, communication, employee
                relations.</small
              >
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-cash-coin fs-1 text-success"></i>
              <h6 class="fw-bold mt-2">Finance Internship</h6>
              <small
                >Reports, accounting basics, budgeting, audits, financial
                analysis.</small
              >
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-palette fs-1 text-warning"></i>
              <h6 class="fw-bold mt-2">UI/UX Design</h6>
              <small
                >Wireframing, prototyping, design tools & user-centered
                design.</small
              >
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-bar-chart-line fs-1 text-danger"></i>
              <h6 class="fw-bold mt-2">Digital Marketing</h6>
              <small
                >SEO, social media, ads, content creation, analytics
                tools.</small
              >
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-graph-up fs-1 text-info"></i>
              <h6 class="fw-bold mt-2">Business Analysis</h6>
              <small
                >BRD/SRS, workflows, requirement gathering &
                documentation.</small
              >
            </div>

            <div class="domain-card p-3 text-center">
              <i class="bi bi-briefcase fs-1 text-secondary"></i>
              <h6 class="fw-bold mt-2">Business Development</h6>
              <small
                >Lead generation, communication, proposals, planning.</small
              >
            </div>
          </div>

          <h3 class="fw-bold mt-5 mb-3 text-center">What You Will Learn</h3>

          <div class="container">
            <div class="row g-4">
              <div class="col-12 col-sm-6 col-lg-4">
                <div class="card h-100 text-center p-3 shadow-sm">
                  <i class="bi bi-people-fill fs-2 text-primary"></i>
                  <h6 class="fw-bold mt-2">Team Collaboration</h6>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-lg-4">
                <div class="card h-100 text-center p-3 shadow-sm">
                  <i class="bi bi-chat-dots fs-2 text-success"></i>
                  <h6 class="fw-bold mt-2">Professional Communication</h6>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-lg-4">
                <div class="card h-100 text-center p-3 shadow-sm">
                  <i class="bi bi-file-earmark-text fs-2 text-info"></i>
                  <h6 class="fw-bold mt-2">Documentation & Reporting</h6>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-lg-4">
                <div class="card h-100 text-center p-3 shadow-sm">
                  <i class="bi bi-tools fs-2 text-warning"></i>
                  <h6 class="fw-bold mt-2">Industry Tools</h6>
                  <small>(Excel, Figma, CRM tools, etc.)</small>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-lg-4">
                <div class="card h-100 text-center p-3 shadow-sm">
                  <i class="bi bi-person-workspace fs-2 text-danger"></i>
                  <h6 class="fw-bold mt-2">Real-Time Tasks</h6>
                </div>
              </div>
            </div>
          </div>

          <h3 class="fw-bold mt-5 mb-3 text-center">Internship Includes</h3>

          <div class="container">
            <div class="row g-3 justify-content-center">
              <!-- Card 1 -->
              <div class="col-md-3 col-sm-6">
                <div class="feature-card p-3 text-center">
                  <i class="bi bi-patch-check fs-2 text-primary"></i>
                  <h6 class="mt-2 fw-bold">Certificate of Completion</h6>
                </div>
              </div>

              <!-- Card 2 -->
              <div class="col-md-3 col-sm-6">
                <div class="feature-card p-3 text-center">
                  <i class="bi bi-file-earmark-person fs-2 text-primary"></i>
                  <h6 class="mt-2 fw-bold">Resume Building Guidance</h6>
                </div>
              </div>

              <!-- Card 3 -->
              <div class="col-md-3 col-sm-6">
                <div class="feature-card p-3 text-center">
                  <i class="bi bi-person-video3 fs-2 text-primary"></i>
                  <h6 class="mt-2 fw-bold">1:1 Mentor Support</h6>
                </div>
              </div>

              <!-- Card 4 -->
              <div class="col-md-3 col-sm-6">
                <div class="feature-card p-3 text-center">
                  <i class="bi bi-briefcase-fill fs-2 text-primary"></i>
                  <h6 class="mt-2 fw-bold">Job-Oriented Training</h6>
                </div>
              </div>
            </div>
          </div>

          <h5 class="fw-bold mt-4 mb-2">Eligibility</h5>
          <ul>
            <li>Any graduate / undergraduate</li>
            <li>Good communication & interest in the domain</li>
          </ul>

          <h5 class="fw-bold mt-4 mb-2">Duration</h5>
          <ul>
            <li>4 – 8 Weeks (Based on domain)</li>
          </ul>

          <div class="text-center mt-4">
           <a
  class="btn btn-primary px-4 py-2"
  routerLink="/internship/apply/"
  href="/internship/apply/?type=non-programming"
  [queryParams]="{ type: 'non-programming' }"
>
  Apply Now
</a>

            <a
              routerLink="/careers"
              href="/careers"
              class="btn btn-outline-secondary px-4 py-2 ms-2"
              style="border-radius: 6px"
            >
              Back
            </a>
          </div>
        </div>
      </div>
    </div>
 